<script>
import { mapState, mapActions } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { required } from '@validations'

export default {
   name: 'Pengaturan',
   components: { BCardCode },
   data() {
      return {
         required,
         form: {
            sicantik_username: null,
            sicantik_password: null,
            sicantik_token: null,
            oss_user_key: null,
            oss_token: null,
            simbg_username: null,
            simbg_password: null,
         },
         options: {
            status: [
               { value: 1, text: 'enable' },
               { value: 0, text: 'disable' },
            ],
         },
      }
   },
   computed: {
      ...mapState({
         myData: state => state.Pengaturan.items,
      }),
      isLoading() {
         return this.$store.state.isLoading
      },
   },
   mounted() {
      this.loadData()
   },
   methods: {
      ...mapActions({
         getData: 'Pengaturan/getData',
         saveData: 'Pengaturan/saveData',
         redisFlush: 'Pengaturan/redisFlush',
      }),
      loadData() {
         this.getData().then(res => {
            this.form = res
            console.log(res)
         })
      },
      onSave() {
         this.$refs.myForm.validate().then(success => {
            if (success) {
               this.saveData(this.form).then(() => {
                  this.loadData()
                  this.$bvToast.toast('Data berhasil disimpan.', {
                     title: 'Berhasil', variant: 'success', solid: true,
                  })
               })
            }
         })
      },
      onRefresh() {
         this.loadData()
      },
      onRedisFlush() {
         this.$swal({
            title: 'Konfirmasi',
            text: 'Apakah Anda yakin ingin melakukan flush redis?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
         }).then(result => {
            if (result.value) {
               this.redisFlush().then(() => {
                  this.$bvToast.toast('Redis berhasil di flush.', {
                     title: 'Berhasil', variant: 'success', solid: true,
                  })
               }, () => {
                  this.$bvToast.toast('Flush redis gagal.', {
                     title: 'Error', variant: 'danger', solid: true,
                  })
               })
            }
         })
      },
   },
}
</script>

<template>
   <b-card-code title="Form">
      <b-row>
         <b-col cols="12">
            <div class="d-flex justify-content-end">
               <b-button-group class="mb-1 align-self-end">
                  <b-button
                     v-b-tooltip.hover.top="'Simpan'"
                     v-b-toggle.collapse-filter
                     variant="outline-secondary"
                     size="sm"
                     :disabled="isLoading"
                     @click="onSave()"
                  >
                     <b-spinner v-if="isLoading" small />
                     <feather-icon v-if="!isLoading" icon="SaveIcon" />
                  </b-button>
                  <b-button
                     v-b-tooltip.hover.top="'Refresh'"
                     variant="outline-secondary"
                     size="sm"
                     :disabled="isLoading"
                     @click="onRefresh()"
                  >
                     <b-spinner v-if="isLoading" small />
                     <feather-icon v-if="!isLoading" icon="RefreshCwIcon" />
                  </b-button>
                  <b-button
                     v-b-tooltip.hover.top="'Flush Redis'"
                     variant="outline-danger"
                     size="sm"
                     :disabled="isLoading"
                     @click="onRedisFlush()"
                  >
                     <b-spinner v-if="isLoading" small />
                     <feather-icon v-if="!isLoading" icon="Trash2Icon" />
                  </b-button>
               </b-button-group>
            </div>
         </b-col>
      </b-row>
      <validation-observer ref="myForm">
         <b-form>
            <b-row>
               <b-col cols="12" md="4">
                  <b-card class="border-dark" title="OSS">
                     <b-form-group label="OSS Username" label-for="Username">
                        <validation-provider #default="{ errors }" name="Username" rules="required">
                           <b-form-input
                              v-model="form.oss_username"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="OSS Password" label-for="OSS Password">
                        <validation-provider #default="{ errors }" name="OSS Password" rules="required">
                           <b-form-input
                              v-model="form.oss_password"
                              :state="errors.length > 0 ? false : true"
                              type="password"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="OSS User Key" label-for="OSS User Key">
                        <validation-provider #default="{ errors }" name="OSS User Key" rules="required">
                           <b-form-input
                              v-model="form.oss_user_key"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="OSS Token" label-for="OSS Token">
                        <validation-provider #default="{ errors }" name="OSS Token" rules="required">
                           <b-form-input
                              v-model="form.oss_token"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>

                  </b-card>
               </b-col>
               <b-col cols="12" md="4">
                  <b-card class="border-dark" title="SICANTIK">
                     <b-form-group label="Username" label-for="Username">
                        <validation-provider #default="{ errors }" name="Username" rules="required">
                           <b-form-input
                              v-model="form.sicantik_username"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="Password" label-for="Password">
                        <validation-provider #default="{ errors }" name="Password" rules="required">
                           <b-form-input
                              v-model="form.sicantik_password"
                              :state="errors.length > 0 ? false : true"
                              type="password"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="Token" label-for="Token">
                        <validation-provider #default="{ errors }" name="Token" rules="required">
                           <b-form-input
                              v-model="form.sicantik_token"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                  </b-card>
               </b-col>
               <b-col cols="12" md="4">
                  <b-card class="border-dark" title="SIMBG">
                     <b-form-group label="Username" label-for="Cookie Session">
                        <validation-provider #default="{ errors }" name="Cookie Session" rules="required">
                           <b-form-input
                              v-model="form.simbg_username"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="Password" label-for="Cookie CSRF">
                        <validation-provider #default="{ errors }" name="Cookie CSRF" rules="required">
                           <b-form-input
                              v-model="form.simbg_password"
                              :state="errors.length > 0 ? false : true"
                              type="password"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                  </b-card>
               </b-col>
               <b-col cols="12" md="4">
                  <b-card class="border-dark" title="MPPD">
                     <b-form-group label="Username" label-for="Username">
                        <validation-provider #default="{ errors }" name="Username" rules="required">
                           <b-form-input
                              v-model="form.mppd_username"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="Password" label-for="Password">
                        <validation-provider #default="{ errors }" name="Password" rules="required">
                           <b-form-input
                              v-model="form.mppd_password"
                              :state="errors.length > 0 ? false : true"
                              type="password"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="Token" label-for="Token">
                        <validation-provider #default="{ errors }" name="Token" rules="required">
                           <b-form-input
                              v-model="form.mppd_token"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                  </b-card>
               </b-col>
               <b-col cols="12" md="4">
                  <b-card class="border-dark" title="Proxy">
                     <b-form-group label="Proxy Enable" label-for="Proxy Enable">
                        <validation-provider #default="{ errors }" name="Status " rules="required">
                           <b-form-select
                              v-model="form.proxy_enable"
                              :options="options.status"
                              :state="errors.length > 0 ? false : true"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                     <b-form-group label="Proxy List" label-for="Proxy List">
                        <validation-provider #default="{ errors }" name="Proxy List" rules="required">
                           <b-form-input
                              v-model="form.proxy"
                              :state="errors.length > 0 ? false : true"
                              type="text"
                           />
                           <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                     </b-form-group>
                  </b-card>
               </b-col>
            </b-row>
         </b-form>
      </validation-observer>
   </b-card-code>
</template>

<style></style>
